<div class="role20-form-container">
  <p-toast></p-toast>
  <app-sheet-loader [visible]="isLoading" />

  <p-card [header]="formTitle" [subheader]="isDev ? '[710000] Notes - Corporate information' : ''" *ngIf="!isLoading && schema && form" class="form-card">

    <div class="bg-gray-200 text-black-700 text-sm font-medium px-2 py-1">Disclosure on corporate information</div>

    <form [formGroup]="form">
      <!-- Dynamic Fields and Section Headers -->
      <ng-container *ngFor="let control of schema.controls">
        <!-- Section Header -->
        <div *ngIf="control.ui.control === 'section-header'" class="bg-gray-200 text-black-700 text-sm font-medium px-3 py-1">
          {{ control.label }}
        </div>

        <!-- Form Fields -->
        <div class="form-field" *ngIf="control.ui.control !== 'section-header' && shouldDisplayField(control)">
          <label class="field-label" [class.required]="isFieldRequired(control)">
            {{ control.label }}<app-required-marker [when]="isFieldRequired(control)" />
          </label>

          <!-- Text Input -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'text'">
            <input
              type="text"
              pInputText
              [formControlName]="control.qname"
              [placeholder]="control | placeholder"
              class="w-full"
            />

            <small class="error-message"
                   *ngIf="getControl(control.qname)?.invalid && getControl(control.qname)?.touched">
              <span *ngIf="getControl(control.qname)?.errors?.['required']">
                {{ getErrorMessage(control, 'required') }}
              </span>
              <span *ngIf="getControl(control.qname)?.errors?.['pattern']">
                {{ getErrorMessage(control, 'pattern') }}
              </span>
            </small>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Rich-text (WYSIWYG) field — same preview + pop-out editor as role
               750000 (AS-897 rollout). The control value stays a plain HTML
               string; required parity holds because the field normalizes empty
               content to '' (the pure validator's isEmpty and Validators.required
               both treat '' as empty — role 20 is on PURE_VERDICT_SHEETS). -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'richtext'">
            <app-rich-text-field
              [formControlName]="control.qname"
              [title]="control.label"
              [placeholder]="control | placeholder: 'Click to add content…'"
              [invalid]="!!(getControl(control.qname)?.invalid && getControl(control.qname)?.touched)"
            ></app-rich-text-field>

            <small class="error-message"
                   *ngIf="getControl(control.qname)?.invalid && getControl(control.qname)?.touched">
              <span *ngIf="getControl(control.qname)?.errors?.['required']">
                {{ getErrorMessage(control, 'required') }}
              </span>
            </small>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Date Picker -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'date'">
            <p-datepicker
              [inputId]="control.qname"
              [formControlName]="control.qname"
              dateFormat="yy-mm-dd"
              [showIcon]="true"
              iconDisplay="input"
              [placeholder]="control | fixedPlaceholder: 'Select a date'"
              class="w-full"
            ></p-datepicker>

            <small class="error-message"
                   *ngIf="getControl(control.qname)?.invalid && getControl(control.qname)?.touched">
              <span *ngIf="getControl(control.qname)?.errors?.['required']">
                {{ getErrorMessage(control, 'required') }}
              </span>
            </small>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

        </div>
      </ng-container>
    </form>

    <!-- Form Status -->
    <!-- <div *ngIf="!isLoading && schema && form" class="form-status mt-4">
      <p>
        <strong>Form Status:</strong>
        <span [class]="form.valid ? 'text-green-600' : 'text-red-600'">
          {{ form.valid ? 'Valid ✓' : 'Invalid - Please fill required fields' }}
        </span>
      </p>
      <p>
        <strong>Total Fields:</strong> {{ schema.controls.length || 0 }}
      </p>
      <p>
        <strong>Auto-save:</strong>
        <span class="text-green-600">Enabled (500ms debounce)</span>
      </p>
    </div> -->
    <submit-for-validation
      [form]="form"
      [sheetKey]="'notesCorporateInformation'"
      [formTitle]="formTitle"
      (cancelConfirmed)="onCancelConfirmed()"
    ></submit-for-validation>
  </p-card>
</div>
